import React, { useEffect, useRef, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDatumItemList } from "../../api/formRequest";
import { getItemDetail } from "../../api/ItemRequest";
import { getDatum_One } from "../../api/DatumManipulation";
import DatumView from "./DatumView";
import DatumList from "./DatumListSheet";
import SimpleBar from "simplebar-react";
import { modalDatumView } from "../../actions/ModalAction";
import {
  actionUpdateFormCategory,
  actionUpdateFormMadeBy,
  actionUpdateFormSoldBy,
  actionUpdateFormSubstitute,
} from "../../actions/formAction";
import { submitDatum } from "../../api/DatumSubmitRequest";
import "simplebar-react/dist/simplebar.min.css";
import { RELATION } from "../../const";
import { TbCategory2, TbReplace } from "react-icons/tb";
import { IoHammerOutline } from "react-icons/io5";
import { MdOutlineSell } from "react-icons/md";
import { getRelations } from "../../api/ValuesRequest";
import { getDatumRelation } from "../../api/formRequest";

const DatumWill = memo(({ 
  type, 
  rowInd, 
  colInd, 
  productRefId,
  productFilename,
  cellRefId,
  cellFilename
}) => {
  const { tempItems } = useSelector((state) => state.tempItemReducer);
  const [ref1, setRef1] = useState('');
  const [ref2, setRef2] = useState('');

  // Remove formData selector entirely
  // const formData = useSelector((state) => state.formReducer.formData);

  const getImagePath = async (id, type_) => {
      if (!id || id === "-1" || id.startsWith("temp_") || id.includes("reference;")) return;
      try {
          const data = (await getItemDetail(id)).data;
          if (type_ === 1) setRef1(process.env.REACT_APP_PUBLIC_FOLDER + data.image);
          else setRef2(process.env.REACT_APP_PUBLIC_FOLDER + data.image);
      } catch (error) {
          console.log("Failure fetching image for", id, error);
      }
  };

  useEffect(() => {
      // Resolve product image (ref1)
      const resolveProductImage = async () => {
          if (productRefId?.startsWith("temp_")) {
              const tempItem = tempItems[productRefId];
              if (tempItem) setRef1(process.env.REACT_APP_PUBLIC_FOLDER + tempItem.image);
          } else if (productRefId?.includes("reference;")) {
              if (productFilename) {
                  setRef1(process.env.REACT_APP_PUBLIC_FOLDER + productFilename);
              }
          } else if (productRefId === "-1") {
              if (productFilename) {
                  setRef1(process.env.REACT_APP_PUBLIC_FOLDER + productFilename);
              }
          } else {
              await getImagePath(productRefId, 1);
          }
      };

      // Resolve cell image (ref2)
      const resolveCellImage = async () => {
          if (cellRefId?.startsWith("temp_")) {
              const tempItem = tempItems[cellRefId];
              if (tempItem) setRef2(process.env.REACT_APP_PUBLIC_FOLDER + tempItem.image);
          } else if (cellRefId?.includes("reference;")) {
              if (cellFilename) {
                  setRef2(process.env.REACT_APP_PUBLIC_FOLDER + cellFilename);
              }
          } else if (cellRefId === "-1") {
              if (cellFilename) {
                  setRef2(process.env.REACT_APP_PUBLIC_FOLDER + cellFilename);
              }
          } else {
              await getImagePath(cellRefId, 2);
          }
      };

      resolveProductImage();
      resolveCellImage();

  }, [productRefId, productFilename, cellRefId, cellFilename, tempItems]);

  return (
        <>
          {type === RELATION.CATEGORY && (
            <div style={{ border: "1px solid #3498DB", borderRadius: "5px", padding: "2px" }}>
              <div style={{ textAlign: "center" }}>A datum will be created to show</div>
              <div className="flex" style={{ justifyContent: "center", gap: "1rem", alignItems: "center" }}>
                <img className="w-4 h-4" src={ref1} loading="lazy"/>
                <TbCategory2 />
                <img className="w-4 h-4" src={ref2} loading="lazy"/>
              </div>
            </div>
          )}
          {type === RELATION.MADEBY && (
            <div style={{ border: "1px solid #3498DB", borderRadius: "5px", padding: "2px" }}>
              <div style={{ textAlign: "center" }}>A datum will be created to show</div>
              <div className="flex" style={{ justifyContent: "center", gap: "1rem", alignItems: "center" }}>
                <img className="w-4 h-4" src={ref2} />
                <IoHammerOutline />
                <img className="w-4 h-4" src={ref1} />
              </div>
            </div>
          )}
          {type === RELATION.SOLDBY && (
            <div style={{ border: "1px solid #3498DB", borderRadius: "5px", padding: "2px" }}>
              <div style={{ textAlign: "center" }}>A datum will be created to show</div>
              <div className="flex" style={{ justifyContent: "center", gap: "1rem", alignItems: "center" }}>
                <img className="w-4 h-4" src={ref2} />
                <MdOutlineSell />
                <img className="w-4 h-4" src={ref1} />
              </div>
            </div>
          )}
          {type === RELATION.SUBSTITUTE && (
            <div style={{ border: "1px solid #3498DB", borderRadius: "5px", padding: "2px" }}>
              <div style={{ textAlign: "center" }}>A datum will be created to show</div>
              <div className="flex" style={{ justifyContent: "center", gap: "1rem", alignItems: "center" }}>
                <img className="w-4 h-4" src={ref1} />
                <TbReplace />
                <img className="w-4 h-4" src={ref2} />
              </div>
            </div>
          )}
        </>
      );
}, (prevProps, nextProps) => {
  return (
      prevProps.productRefId === nextProps.productRefId &&
      prevProps.productFilename === nextProps.productFilename &&
      prevProps.cellRefId === nextProps.cellRefId &&
      prevProps.cellFilename === nextProps.cellFilename &&
      prevProps.type === nextProps.type
  );
});

function ShowDatumList({
  userId,
  productId,
  refId,
  type,
  rowInd,
  colInd,
  reference,
  createFlag,
  onShowDetail,
  themes,
  sources,
  productData,
  categoryData,
  madebyData,
  soldbyData,
  substituteData
}) {

  const divContainer = useRef(null);
  const [data, setData] = useState([]);
  const [disp, setDisp] = useState(true);
  const [creating, setCreating] = useState(false)
  const dispatch = useDispatch();
  const sessionId = localStorage.getItem('sessionId');
  console.log("Reference: ", reference)

  const mapRelationId = async (text) => {
    const res = await getRelations()
    const data = res.data;
    let map = ""
    for (let i = 0; i< data.length; i++) {
      if (data[i].text === text) map = data[i]._id
    }
    return map;

  }
  
  useEffect(() => {
    if (!reference.datumId || reference.datumId === "") {
      setDisp(false);
      return;
    }
    const getData = async () => {
      try {
        const quant = await getDatum_One(reference.datumId);
        if (quant.data === null)
        {
          setDisp(false);
        } else {
          setDisp(true);
        }
      } catch (error) {
        setDisp(false);
        // console.error("Failed to fetch data:", error);
      }
    };
    getData();
    
  }, [reference.datumId]);

  useEffect(() => {
    if (userId === "" || productId === "" || refId === "" || type === "") {
      setData([]);
      return;
    }
    if (refId.includes("reference;") || refId === "-1" || productId === "-1") {
      setData([]);
      return;
    }
    if (refId.startsWith("temp_") || productId.startsWith("temp_")) {
      setData([])
      return;
    }
    if (reference.datumId && reference.datumId !== "") {
      setData([]);
      return
    }
    if(creating) {
      setData([]);
      return;
    }
    getDatumItemList(userId, productId, refId, type)
      .then((data) => {
        setData(data.data);
      })
      .catch((err) => {
        setData([]);
        console.log(err);
      });
  }, [productId, refId, type, creating]);

  useEffect(() => {
    if (createFlag === 0) return;
    if (reference.datumId !== "" && reference.datumId !== null) return;
    if (refId === "-1" || productId === "-1") return;
    if (refId?.startsWith("temp_") || productId?.startsWith("temp_")) return;
    dispatch({ type: "DATUM_CREATION_START" });
    setCreating(true)
    const createDatum = async () => {
      try {
        let relation;
        if (type === RELATION.CATEGORY) {
          relation = {
            ref1: productId,
            text: "belongs to (category)",
            ref2: refId,
            relationId: await mapRelationId("belongs to (category)")
          };
        } else if (type === RELATION.MADEBY) {
          relation = {
            ref1: refId,
            text: "makes",
            ref2: productId,
            relationId: await mapRelationId("makes")
          };
        } else if (type === RELATION.SOLDBY) {
          relation = {
            ref1: refId,
            text: "sells",
            ref2: productId,
            relationId: await mapRelationId("sells")
          };
        } else if (type === RELATION.SUBSTITUTE) {
          relation = {
            ref1: productId,
            text: "replaces",
            ref2: refId,
            relationId: await mapRelationId("replaces")
          };
        }
        let createdItem = (
          await submitDatum({
            datumText: "",
            references: [productId, refId],
            relations: [relation],
            ...(sources ? { sources } : {}),
            themes: themes,
            userId: userId,
            sessionId
          })
        ).data;
        if (type === RELATION.CATEGORY) {
          dispatch(
            actionUpdateFormCategory({
              key: rowInd,
              category: {
                ...reference,
                datumId: createdItem._id,
              },
            })
          );
        } else if (type === RELATION.MADEBY) {
          dispatch(
            actionUpdateFormMadeBy({
              rkey: rowInd,
              ckey: colInd,
              madeby: {
                ...reference,
                datumId: createdItem._id,
              },
            })
          );
        } else if (type === RELATION.SOLDBY) {
          dispatch(
            actionUpdateFormSoldBy({
              rkey: rowInd,
              ckey: colInd,
              soldby: {
                ...reference,
                datumId: createdItem._id,
              },
            })
          );
        } else if (type === RELATION.SUBSTITUTE) {
          dispatch(
            actionUpdateFormSubstitute({
              rkey: rowInd,
              ckey: colInd,
              substitute: {
                ...reference,
                datumId: createdItem._id,
              },
            })
          );
        }
      } catch (error) {
        console.log("Datum creation failed: ", error)
      } finally {
        dispatch({ type: "DATUM_CREATION_COMPLETE" });
        setCreating(false);
      }
      setCreating(false)
    };
    createDatum();
  }, [createFlag]);
  
  useEffect(() => {
    if (divContainer && divContainer.current) {
      divContainer.current.focus();
    }
  }, [data]);
  const onSelectOther = (e) => {
    if (e.relatedTarget === null) {
      setData([]);
    }
  };
  const onSelectDatum = (datum) => {
    if (datum === null) return;
    if (type === RELATION.CATEGORY) {
      dispatch(
        actionUpdateFormCategory({
          key: rowInd,
          category: {
            ...reference,
            datumId: datum._id,
          },
        })
      );
    } else if (type === RELATION.MADEBY) {
      dispatch(
        actionUpdateFormMadeBy({
          rkey: rowInd,
          ckey: colInd,
          madeby: {
            ...reference,
            datumId: datum._id,
          },
        })
      );
    } else if (type === RELATION.SOLDBY) {
      dispatch(
        actionUpdateFormSoldBy({
          rkey: rowInd,
          ckey: colInd,
          soldby: {
            ...reference,
            datumId: datum._id,
          },
        })
      );
    } else if (type === RELATION.SUBSTITUTE) {
      dispatch(
        actionUpdateFormSubstitute({
          rkey: rowInd,
          ckey: colInd,
          substitute: {
            ...reference,
            datumId: datum._id,
          },
        })
      );
    }
    setData([]);
  };
  // const GetText = ({ type }) => {
  //   const rowData = formData[rowInd];
  //   if (productId === "-1" && formData[rowInd].product.filename.cloudName === "") {
  //     return "";
  //   }  
  //   if (type === RELATION.SUBSTITUTE) {
  //     const cellData = rowData.substitute[colInd];
  //     // if (cellData.refString == "" && cellData.refId == "-1") {
  //     // if (cellData.refId !== "-1" && productId !== "-1") {
  //     if (cellData.refId === "-1" && cellData.filename.cloudName === "") {
  //       return "";
  //     }
  //     // if (cellData.refString == "" && cellData.filename.cloudName == '') {
  //     //     return "";
  //     // } 
  //     else {
  //       return <DatumWill type={type} rowInd={rowInd} colInd={colInd} />;
  //     }
  //     // }
  //   } else if (type === RELATION.MADEBY) {
  //     const cellData = rowData.madeby[colInd];
  //     if (cellData.refId === "-1" && cellData.filename.cloudName === "") {
  //       return "";
  //     }
  //     // if ( cellData.refString == "" && cellData.refId == "-1") {
  //     // if (cellData.refId !== "-1" && productId !== "-1") {
  //     // if (cellData.refString == "" && cellData.filename.cloudName == '') {
  //     //   return "";
  //     // } 
  //     else {
  //       return <DatumWill type={type} rowInd={rowInd} colInd={colInd} />;
  //     }
  //     // }
  //   } else if (type === RELATION.SOLDBY) {
  //     const cellData = rowData.soldby[colInd];
  //     if (cellData.refId === "-1" && cellData.filename.cloudName === "") {
  //       return "";
  //     }
  //     // if (cellData.refString == "" && cellData.refId == "-1") {
  //     // if (cellData.refId !== "-1" && productId !== "-1") {
  //     // if (cellData.refString == "" && cellData.filename.cloudName == '') {
  //     //   return "";
  //     // } 
  //     else {
  //       return <DatumWill type={type} rowInd={rowInd} colInd={colInd} />;
  //     }
  //     // }
  //   } else if (type === RELATION.CATEGORY) {
  //     const cellData = rowData.category;
  //     if (cellData.refId === "-1" && cellData.filename.cloudName === "") {
  //       return "";
  //     }
  //     // if (cellData.refString == "" && cellData.refId == "-1") {
  //     // if (cellData.refString == "" && cellData.filename.cloudName == '') {
  //     //   return "";
  //     // } 
  //     else {
  //       return <DatumWill type={type} rowInd={rowInd} colInd={colInd} />;
  //     }
  //   }

  // };

  const GetText = ({ type }) => {
    const hasProduct = productId !== "-1" || productData?.filename?.cloudName;
    if (!hasProduct) return "";

    const getCellData = () => {
        if (type === RELATION.CATEGORY) return categoryData;
        if (type === RELATION.MADEBY) return madebyData;
        if (type === RELATION.SOLDBY) return soldbyData;
        if (type === RELATION.SUBSTITUTE) return substituteData;
    };

    const cellData = getCellData();
    if (!cellData) return "";

    if (cellData.refId === "-1" && cellData.filename?.cloudName === "") return "";

    return (
        <DatumWill
            type={type}
            rowInd={rowInd}
            colInd={colInd}
            productRefId={productData?.refId}
            productFilename={productData?.filename?.cloudName}
            cellRefId={cellData?.refId}
            cellFilename={cellData?.filename?.cloudName}
        />
    );
  };
  const onRemove = () => {
    onSelectDatum({ _id: null });
  };
  const onDetail = () => {
    dispatch(modalDatumView(reference.datumId));
    onShowDetail(true);
  };

  return (
    <div className="mt-1">
        {reference.datumId && reference.datumId !== "" && disp ? (
            <DatumView
                productId={productId}
                secondId={refId}
                datumId={reference.datumId}
                type={type}
                onRemove={onRemove}
                onDetail={onDetail}
            />
        ) : (
            <>
                {data.length > 0 ? (
                    <div ref={divContainer} tabIndex={"0"} className="shadowGrayLarge" onBlur={(e) => onSelectOther(e)}>
                        <SimpleBar style={{ maxHeight: 120 }}>
                            <div className="tool-simpleBar-inside-container">
                                {data.map((el, index) => (
                                    <div key={index} onClick={() => onSelectDatum(el)}>
                                        <DatumList data={el} id={index} />
                                    </div>
                                ))}
                            </div>
                        </SimpleBar>
                    </div>
                ) : (
                    <GetText type={type} />
                )}
            </>
        )}
    </div>
  )
}

export default memo(ShowDatumList, (prevProps, nextProps) => {
  return (
      prevProps.productId === nextProps.productId &&
      prevProps.refId === nextProps.refId &&
      prevProps.createFlag === nextProps.createFlag &&
      prevProps.reference?.datumId === nextProps.reference?.datumId &&
      prevProps.productData === nextProps.productData &&
      prevProps.categoryData === nextProps.categoryData &&
      prevProps.madebyData === nextProps.madebyData &&
      prevProps.soldbyData === nextProps.soldbyData &&
      prevProps.substituteData === nextProps.substituteData
  );
});
